import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class SociosDividendosService {
    _getHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }

    // ── Extracción de socios desde PDF (IA) ──────────────────────────────────

    async extractSociosFromPdf(pdfFile, id_company, token) {
        try {
            const formData = new FormData();
            formData.append('pdf', pdfFile);
            formData.append('id_company', id_company);

            const response = await axios.post(
                `${API_BASE_URL}/api/socios-dividendos/socios/extract-from-pdf`,
                formData,
                {
                    params: { id_company },
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            return response.data;
        } catch (error) {
            this._handleError(error, 'Error al extraer socios del PDF');
        }
    }

    _handleError(error, defaultMessage) {
        if (error.response) {
            throw new Error(error.response.data.error || error.response.data.message || defaultMessage);
        } else if (error.request) {
            throw new Error('No se pudo conectar con el servidor');
        } else {
            throw new Error(error.message || defaultMessage);
        }
    }

    // ── Socios (maestro) ──────────────────────────────────────────────────────

    async getSocios(id_company, token) {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/socios-dividendos/socios`, {
                params: { id_company },
                headers: this._getHeaders(token)
            });
            return response.data.data || [];
        } catch (error) {
            this._handleError(error, 'Error al obtener socios');
        }
    }

    async createSocio(data, id_company, token) {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/socios-dividendos/socios`,
                data,
                { params: { id_company }, headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al crear socio');
        }
    }

    async updateSocio(id, data, id_company, token) {
        try {
            const response = await axios.put(
                `${API_BASE_URL}/api/socios-dividendos/socios/${id}`,
                data,
                { params: { id_company }, headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al actualizar socio');
        }
    }

    async deleteSocio(id, id_company, token) {
        try {
            await axios.delete(`${API_BASE_URL}/api/socios-dividendos/socios/${id}`, {
                params: { id_company },
                headers: this._getHeaders(token)
            });
        } catch (error) {
            this._handleError(error, 'Error al eliminar socio');
        }
    }

    // ── Retiros, remesas y dividendos ─────────────────────────────────────────

    async getDividendos(id_company, anio, token) {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/socios-dividendos/dividendos`, {
                params: { id_company, anio },
                headers: this._getHeaders(token)
            });
            return response.data.data || [];
        } catch (error) {
            this._handleError(error, 'Error al obtener dividendos');
        }
    }

    async createDividendo(data, id_company, token) {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/socios-dividendos/dividendos`,
                data,
                { params: { id_company }, headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al crear registro');
        }
    }

    async updateDividendo(id, data, id_company, token) {
        try {
            const response = await axios.put(
                `${API_BASE_URL}/api/socios-dividendos/dividendos/${id}`,
                data,
                { params: { id_company }, headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al actualizar registro');
        }
    }

    async deleteDividendo(id, id_company, token) {
        try {
            await axios.delete(`${API_BASE_URL}/api/socios-dividendos/dividendos/${id}`, {
                params: { id_company },
                headers: this._getHeaders(token)
            });
        } catch (error) {
            this._handleError(error, 'Error al eliminar registro');
        }
    }

    // ── Retiros en exceso ─────────────────────────────────────────────────────

    async getRetirosExceso(id_company, anio, token) {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/socios-dividendos/retiros-exceso`, {
                params: { id_company, anio },
                headers: this._getHeaders(token)
            });
            return response.data.data || [];
        } catch (error) {
            this._handleError(error, 'Error al obtener retiros en exceso');
        }
    }

    async createRetiroExceso(data, id_company, token) {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/socios-dividendos/retiros-exceso`,
                data,
                { params: { id_company }, headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al crear retiro en exceso');
        }
    }

    async updateRetiroExceso(id, data, id_company, token) {
        try {
            const response = await axios.put(
                `${API_BASE_URL}/api/socios-dividendos/retiros-exceso/${id}`,
                data,
                { params: { id_company }, headers: this._getHeaders(token) }
            );
            return response.data.data;
        } catch (error) {
            this._handleError(error, 'Error al actualizar retiro en exceso');
        }
    }

    async deleteRetiroExceso(id, id_company, token) {
        try {
            await axios.delete(`${API_BASE_URL}/api/socios-dividendos/retiros-exceso/${id}`, {
                params: { id_company },
                headers: this._getHeaders(token)
            });
        } catch (error) {
            this._handleError(error, 'Error al eliminar retiro en exceso');
        }
    }
}

const sociosDividendosService = new SociosDividendosService();
export default sociosDividendosService;
